import React from 'react'
// BASE Components
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
// Material UI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';

export default function PEFeedbackCompletion({ins, course, dir, tl, componentCommentsCount, title}) {

  return (
    <>
      <Box className="flex items-center p-16 w-full">
        <Typography className="text-16 font-bold grow">
          {title}:
        </Typography>
        <Chip
          icon={<BASESvgIcon size={20}>heroicons-outline:chat</BASESvgIcon>}
          label={componentCommentsCount('instructions')}
          variant="outlined"
          className="mx-16"
        />
        <Button
          variant="outlined"
          color="primary"
          component={NavLinkAdapter}
          to={`comments/new/edit?c=${title}&t=${title}`}
          startIcon={<BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>}
          size="small"
        >
          Add
        </Button>
      </Box>
      {ins.filter(data => data.course === course || data.course === 'Default').map((data, index) => (
        <Paper key={`ins-${data.title}-${index}`} elevation={0} variant="outlined" square className="p-16 m-16 mt-0">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {data.course === 'Default' ? (
                <Typography 
                  className="m-0 wysiwyg"
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: data.content }}
                />
              ) : (
                <Typography 
                  className={`${tl} m-0 wysiwyg`}
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: data.content }}
                  dir={dir}
                />
              )}
              
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  )
}
